import React from "react";
import { ThemeProvider } from "styled-components";
import { Input, Clear, Container, Contain } from "./styles";

const AxlSearchBox = ({
  onEnter,
  onKeyPress,
  onChange,
  theme,
  placeholder,
  style,
  value,
  clearValue,
}) => {
  const onKeyUp = (event) => {
    onEnter && event.key === "Enter" && onEnter(event);
    onKeyPress && onKeyPress(event);
  };

  return (
    <ThemeProvider theme={{ type: theme || "default" }}>
      <Contain>
        <Container>
          <Input
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onKeyUp={onKeyUp}
            style={style}
          />
          <Clear onClick={clearValue} />
        </Container>
      </Contain>
    </ThemeProvider>
  );
};

export default AxlSearchBox;
